/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/backspace-1214641': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.77 11.36l-5-6A1 1 0 0016 5H5a3 3 0 00-3 3v8a3 3 0 003 3h11a1 1 0 00.77-.36l5-6a1 1 0 000-1.28zM15.53 17H5a1 1 0 01-1-1V8a1 1 0 011-1h10.53l4.17 5zm-2.82-7.71a1 1 0 00-1.42 0L10 10.59l-1.29-1.3a1 1 0 10-1.42 1.42L8.59 12l-1.3 1.29a1 1 0 000 1.42 1 1 0 001.42 0l1.29-1.3 1.29 1.3a1 1 0 001.42 0 1 1 0 000-1.42L11.41 12l1.3-1.29a1 1 0 000-1.42z"/>'
  }
})
